export default __webpack_public_path__ + "static/SleighLogo-Black-08caf12d84a032c4d880934650192f43.png";